import { createTheme } from "@mui/material/styles";
import { componentOverrides } from "./componentOverrides";

const baseTheme = createTheme({
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  palette: {
    mode: "light",
    primary: {
      light: "#3e6eaa",
      main: "#0e4089",
      dark: "#082d63",
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#718096",
      main: "#42516a",
      dark: "#263349",
      contrastText: "#ffffff",
    },
    error: {
      main: "#c62828",
    },
    warning: {
      main: "#ed8b00",
      contrastText: "#172033",
    },
    success: {
      main: "#2e7d32",
    },
    info: {
      main: "#0277bd",
    },
    background: {
      default: "#f4f6f8",
      paper: "#ffffff",
    },
    text: {
      primary: "#172033",
      secondary: "#5e6b82",
      disabled: "#98a2b3",
    },
    divider: "#dde3ec",
  },
  typography: {
    fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontSize: "clamp(1.5rem, 2vw, 1.875rem)",
      lineHeight: 1.25,
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontSize: "1.375rem",
      lineHeight: 1.3,
      fontWeight: 700,
      letterSpacing: "-0.01em",
    },
    h3: {
      fontSize: "1.125rem",
      lineHeight: 1.4,
      fontWeight: 700,
    },
    h4: {
      fontSize: "1rem",
      lineHeight: 1.45,
      fontWeight: 700,
    },
    h5: {
      fontSize: "0.9375rem",
      lineHeight: 1.5,
      fontWeight: 700,
    },
    h6: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      fontWeight: 700,
    },
    body1: {
      fontSize: "0.9375rem",
      lineHeight: 1.6,
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.55,
    },
    caption: {
      fontSize: "0.75rem",
      lineHeight: 1.5,
      color: "#5e6b82",
    },
    button: {
      fontSize: "0.875rem",
      fontWeight: 600,
    },
  },
  shadows: [
    "none",
    "0 1px 2px rgba(15, 23, 42, 0.05)",
    "0 2px 6px rgba(15, 23, 42, 0.07)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 8px 20px rgba(15, 23, 42, 0.09)",
    ...Array(20).fill("0 12px 32px rgba(15, 23, 42, 0.12)"),
  ],
});

export const theme = createTheme(baseTheme, {
  components: componentOverrides,
});
